
import React, {FC} from 'react';
import classNames from 'classnames';
import PriceDisplay from 'components/utils/PriceDisplay';

import * as styles from './styles.module.scss';

type PricingProps = {
	center?: boolean,
	children?: React.ReactElement,
	savings?: boolean,
	qty: number,
	text: string,
	total: number,
};

const Pricing: FC<PricingProps> = ({
	center,
	children,
	qty,
	savings = true,
	text,
	total,
}) => {
	const refPerScan = 139;
	const refTotal = refPerScan * qty;
	return (
		<div className={classNames({
			[styles.pricing]: true,
			[styles.center]: center,
		})}>
			<p>{text}</p>
			<div className={styles.prices}>
				{total === 0 ? (
					<PriceDisplay price={0} isLoading={true} />
				) : (
					<>
						<em>${refTotal}</em> <PriceDisplay price={total} />
					</>
				)}
			</div>
			{savings && total > 0 && (
				<div className={styles.savings}>
					Save {(100 * (1 - total / refTotal)).toFixed(0)}%
					vs average DEXA cost
				</div>
			)}
			{children}
		</div>
	);
};

export default Pricing;
